<template>

    <div class="card title">
        <div class="card-body title-body pb-2 pl-2 pr-2">
            <h3 class="tile-title is-line mb-2">
                <i class="fa fa-clipboard-list"></i> Trường tuỳ biến: {{label}}
                <span v-if="permissions('data-custom-field_create')" class="btn-add float-right pr-2" @click="create">
                    <i class="icon16-plus-circle-gadient"></i>
                </span>
            </h3>
            <div class="row">
                <div class="col-12 title-template-table table-responsive">
                    <g-loading v-if="firstLoading" />
                    <div v-else-if="listLoading" class="text-center text-primary">
                        <b-spinner></b-spinner>
                    </div>
                    <div v-else-if="!listLoading && !itemCount" class="text-center text-danger">
                        Không tìm thấy thông tin trường tuỳ biến!
                        <br/> 
                        Click <a href='javascript:;' @click="create">vào đây</a> để thêm mới
                    </div>
                    <table v-else class="table b-table table table-hover table-head-fixed table-striped table-hover b-table-selectable b-table-select-single">
                        <thead>
                            <tr>
                                <th class='text-center'>#</th>
                                <th>Tên trường dữ liệu</th>
                                <th>Phân loại rác</th>
                                <th class="text-center">Hiển thị trên danh sách dữ liệu</th>
                                <th class="text-center">Bắt buộc <span class="text-danger">*</span></th>
                                <th class="text-right">Hành động</th>
                            </tr>
                        </thead>
                        <draggable v-model="items" @change="draggableChange" tag="tbody">
                            <tr v-for="item in items" :key="item.key" class="tr-draggable">
                                <td class='text-center'>{{item.position}}</td>
                                <td>
                                    <span :class="(item.blocked ? 'c-signal' : 'c-signal is-success')"><span class="h-word-break">{{item.label}}</span></span>
                                </td>
                                <!--<td>{{ item.key }}</td>-->
                                <!-- <td>
                                    <span v-if="params && params[$params.const.dataFieldSource.key] && params[$params.const.dataFieldSource.key][item.source]" >{{params[$params.const.dataFieldSource.key][item.source]}}</span>
                                </td> -->
                                <td>
                                    <span v-if="params && params[$params.const.dataFieldGroup.key] && params[$params.const.dataFieldGroup.key][item.group]" >{{params[$params.const.dataFieldGroup.key][item.group]}}</span>
                                </td>
                                <td class="text-center"><span v-if="item.show_in_list" class="small text-success" >Hiển thị</span></td>
                                <td class="text-center"><span v-if="item.required" class="small text-danger" >Bắt buộc nhập</span></td>
                                <td class="text-right">
                                    <button type="button" class="btn-sm btn btn-sm btn-outline-gray ml-1 mb-1">
                                        <i class="fa fa-arrows-alt mr-0"></i>
                                    </button>
                            <g-button v-if="permissions('data-custom-field_update')" :loading="updateLoading" size="sm" variant="outline-info" class="ml-1 mb-1" icon="pencil" @click='update(item.id)'/>
                            <g-button v-if="permissions('data-custom-field_del')" :loading="delLoading" size="sm" variant="outline-danger" class="ml-1 mb-1" icon="trash-fill" @click='del(item.id)' />
                            </td>
                            </tr>
                        </draggable>
                    </table>

                    <b-modal v-model="showForm" :title="`${formTitle} thông tin tuỳ biến`" no-close-on-backdrop no-enforce-focus>
                        <form-input  :required='true'  label="Tên trường dữ liệu" :model="formModel" attribute="label" :errors="formErrors"></form-input>
                        <form-input  :required='true'  :disabled="formModel.id" label="Mã" :model="formModel" attribute="key" :errors="formErrors"></form-input>
                        <form-input  :required='true' label="Thứ tự hiển thị" :model="formModel" attribute="position" :errors="formErrors"></form-input>

                        <!-- <parameter-select :type="$params.const.dataFieldSource.key" :label="$params.const.dataFieldSource.label" 
                                          :model="formModel" attribute="source" :errors="formErrors" :filter="{status: 1}"  /> -->
                        <parameter-select :type="$params.const.dataFieldGroup.key" :label="$params.const.dataFieldGroup.label" 
                                          :model="formModel" attribute="group" :errors="formErrors" :filter="{status: 1}"  />
                        <form-checkbox chk-label="Hiển thị trên danh sách dữ liệu" :model="formModel" :errors="formErrors"  attribute="show_in_list" />
                        <form-checkbox chk-label="Bắt buộc nhập" :model="formModel" :errors="formErrors"  attribute="required" />
                        <form-checkbox chk-label="Tạm khoá" :model="formModel" :errors="formErrors"  attribute="blocked" />
                        <template v-slot:modal-footer>
                            <b-button variant="secondary" class="float-right" @click="showForm = false">Huỷ</b-button>
                            <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="save">
                                <b-spinner v-if="saveLoading" small></b-spinner>
                                Lưu lại
                            </b-button>
                        </template>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import list from "@/mixins/List";
    import crud from '@/mixins/CRUD';
    import role from '@/mixins/Role';
    import draggable from 'vuedraggable';
    import ParameterSelect from '@/components/ParameterSelect';

    export default {
        props: ['type', "label"],
        components: {draggable, ParameterSelect},
        mixins: [list, crud, role],
        data: function () {
            return {
                reloadBus: "reloadDataCustomField",
                service: '/data-custom-field',
                defaultFilterFormModel: {
                    parameters: [
                        this.$params.const.dataFieldGroup.key,
                    ],
                    keyword: '',
                    type: this.type,
                },
                defaultFormModel: {
                    type: this.type,
                    label: null,
                    key: null,
                    blocked: 0,
                    required: 1,
                    show_in_list: 1,
                    group: null,
                    source: null,
                    product: []
                },
            }

        },
        watch: {
            "formModel.label": {
                handler(val) {
                    if (val && (!this.formModel.id || !this.formModel.key)) {
                        this.formModel.key = this.$utils.createCode(val);
                    }
                }, deep: true
            },
            "formModel.key": {
                handler(val) {
                    if (val) {
                        this.formModel.key = this.$utils.createCode(val);
                    }
                }, deep: true
            }
        },
        methods: {
            draggableChange: function () {
                this.items.forEach((item, index) => {
                    item.position = index;
                    this.$service({url: `${this.service}/update?id=${item.id}`, method: 'put', data: item}).catch(error => {
                        if (error.response.data.msg) {
                            this.$swal({
                                text: error.response.data.msg,
                                icon: 'error'
                            });
                        }
                    });
                });
            },
        },
        mounted() {
        }
    }
</script>